import { CalendarIcon,IdCardIcon } from "../../../../../assets/icons";

export const PUBLIC_DEFAULT_ID = 1;
export const LICENSE_SIDENAV_COLLAPSE_BREAKPOINT = 767;
export const LICENSE_SUPPORT_EMAIL = "support.opsadvisor@dupont.com";
export const LICENSE_DATE_DISPLAY_FORMAT = "MMM DD, YYYY";
export const LICENSE_ASSIGNED_DATE_KEY = "assignedDate";
export const LICENSE_EXPIRY_DATE_KEY = "expiryDate";

export const LICENSE_SECTIONS_CONFIG = [
  // Removed the technology section for now, since we have only RO
  // {
  //   id: "technology",
  //   label: "licenseProfile.licenseTechnology",
  //   tag: "Technology",
  // },
  { id: "features", label: "licenseProfile.licenseFeatures", tag: "Feature" },
  {
    id: "product-list",
    label: "licenseProfile.licenseProductList",
    tag: "Product",
  },
];

export const LICENSE_CARD_DETAILS_CONFIG = [
  {
    icon: IdCardIcon,
    label: "licenseProfile.licenseName",
    valueKey: "name",
    showKey: null,
    iconProps: { color: "var(--color-primary)" },
  },
  {
    icon: CalendarIcon,
    label: "licenseProfile.licenseAssignedOn",
    valueKey: "assignedDate",
    showKey: "assignedDate",
    iconProps: {},
  },
  {
    icon: CalendarIcon,
    label: "licenseProfile.licenseExpiringOn",
    valueKey: "expiryDate",
    showKey: "expiryDate",
    iconProps: { color: "var(--du-color-red)" },
  },
];
